import { TableHeader } from "@/components/table"
import { Sort } from "@/domains/table-processor"

import { DisplaySortIcon } from "../display-sort-icon"

export const ThMyPool = ({ setSortBy, sortBy }: { setSortBy: (v: Sort) => void; sortBy: Sort }) => {
  return (
    <TableHeader
      className="text-right"
      classNameInner="justify-end"
      onClick={() => {
        setSortBy({
          key: "userBalanceValueUSD",
          direction: sortBy.direction === "asc" ? "desc" : "asc",
          type: "number",
        })
      }}
    >
      My Pool
      <DisplaySortIcon sortBy={sortBy} column="userBalanceValueUSD" />
    </TableHeader>
  )
}
